module.exports = __webpack_public_path__ + "static/media/1-focus.aa189406.svg";